import { Bleed, Bleedable, Card, colors, FlowGrid, Skeleton, useContainerWidth } from '@fs/zion-ui'
import React from 'react'
import SkeletonAnimationSyncDecorator from '../../common/SkeletonAnimationSyncDecorator'

type PersonInfoCardSkeletonProps = {
  lineCount?: number
}
function PersonInfoCardSkeleton({ lineCount }: PersonInfoCardSkeletonProps): JSX.Element {
  return (
    <Card edges="border" backgroundColor={colors.gray00}>
      <Bleed all>
        <Bleedable bottom={0} sides={16} top={12}>
          <Skeleton.H2 />
        </Bleedable>
        <Bleedable bottom={16} sides={16} top={8}>
          <Skeleton.Paragraph lineCount={lineCount} size="md" />
        </Bleedable>
      </Bleed>
    </Card>
  )
}

export default function AboutTabSkeleton(): JSX.Element {
  const atContainerWidth = useContainerWidth()
  const columnCount = atContainerWidth({ default: 1, md: 2, xl: 3 })

  return (
    <SkeletonAnimationSyncDecorator>
      <FlowGrid columnCount={columnCount} data-testid="about-tab-skeleton" gutters="xs" orientation="vertical">
        <PersonInfoCardSkeleton lineCount={12} noGrowY />
        <PersonInfoCardSkeleton lineCount={12} noGrowY />
        <PersonInfoCardSkeleton lineCount={9} noGrowY />
        <PersonInfoCardSkeleton lineCount={20} noGrowY />
        <PersonInfoCardSkeleton lineCount={5} noGrowY />
        <PersonInfoCardSkeleton lineCount={35} noGrowY />
      </FlowGrid>
    </SkeletonAnimationSyncDecorator>
  )
}
